import { useSyncExternalStore } from 'react';

/** Tracks whether a CSS media query currently matches (false when matchMedia is unavailable). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    onChange => {
      const mql = window.matchMedia?.(query);
      mql?.addEventListener('change', onChange);
      return () => mql?.removeEventListener('change', onChange);
    },
    () => !!window.matchMedia?.(query).matches
  );
}
